import { Flex, Container, Heading, Stack, Text } from "@chakra-ui/react";

export default function About() {
  return (
    <Container maxW={"6xl"}>
      <Stack
        textAlign={"center"}
        align={"center"}
        spacing={{ base: 8, md: 10 }}
        py={{ base: 16, md: 26 }}
      >
        <Heading
          fontWeight={600}
          fontSize={{ base: "3xl", sm: "4xl", md: "6xl" }}
          lineHeight={"110%"}
        >
          <Text as={"span"} color={"blue.400"}>
            About Me
          </Text>
        </Heading>
        <Text
          color={"gray.500"}
          maxW={"4xl"}
          fontSize={{ base: "sm", sm: "xl", md: "2xl" }}
        >
          Being a '90s kid seeing the technology evolve with early life
          fascination about computers, the way they can be programmed with a
          personal drive towards solving problems lead me into learning software
          development by following a challenging 9-9-6 military-style coding
          routine at Masai School successfully being a Full Stack Developer.
          <br />
          <br />
          Skilled and professionally experienced in modern web technologies like ReactJS, NextJS and NodeJS,
          quality-driven, and curious to learn and implement new things.
          Currently aimed at upskilling in the craft and solving real-life problems through
          opportunities in the field of Full Stack Development.
        </Text>

        <Flex w={"full"}></Flex>
      </Stack>
    </Container>
  );
}
